export default __webpack_public_path__ + "media/assets/img/icon_img_medium-8a2835ad3083842f5f6ff3ac46970216.png";